export default __webpack_public_path__ + "images/kmha-logo-small.svg";